module.exports = __webpack_public_path__ + "img/icon_city2.f6a1ffe9.png";